@if (option) {
<div class="inner-column" [ngClass]="{'accordion': isAccordion}" (click)="onClicked()">
	@if (optionsImage) {
	<div class="image" [ngClass]="{
			'is-temple': imageClass === 'temple',
			'is-model': imageClass === 'model',
			'is-bridge': imageClass === 'bridge',
			'is-nosepad': imageClass === 'nosepad',
			'is-innerrim': imageClass === 'innerrim'
		}">
		<img id="dcg-image" [src]="optionsImage(option, null)" [alt]="option[optionsText]" />
	</div>
	}
	<div class="description" [ngClass]="{'do-split' : hasSubItems}">
		<div class="flex">
			@if (imageClass === 'temple-design') {
			<div [innerHTML]="option[optionsText]"></div>
			}
			@if (imageClass !== 'model' && imageClass !== 'temple-design') {
			<div [innerHTML]="option[optionsText] | dataTranslate | translate | replaceHash"></div>
			}
			@if (imageClass === 'model') {
			<div class="model-info" [innerHTML]="option[optionsText]"></div>
			}
			<availability-text [variantOrModelIsNew]="variantOrModelIsNew" [date]="option.Discontinued" [omitDiscontinuedLabel]="option.OmitDiscontinuedLabel" [new]="option.New" [useNewDetails]="false"></availability-text>
			@if (imageClass === 'model') {
			<div>
				<div class="model-sizes">{{showSizes(option.ModelSizeCodes)}}</div>
			</div>
			}
		</div>
		@if (hasSubItems) {
		<i class="fa-light fa-angle-down"></i>
		}
	</div>
	@if ((option[optionsDescription2] | dataTranslate | translate) !== null &&(option[optionsDescription2] | dataTranslate | translate).length >0 ) {
	<div class="name">
		<h6 [innerHTML]="(option[optionsDescription2] | dataTranslate | translate) || ''"></h6>
	</div>
	}
	@if (option.limitedEditionData) {
	<div class="limited">
		@if (user?.Type === userTypeConstant.Customer) {
		@if (option.limitedEditionData.quantityAvailable > 0) {
		{{ 'LIMITED.AVAILABLE-MEDIUM' | translate : { 'total' : option.limitedEditionData.quantityTotal} }}
		}
		}
		@else if (user?.Type === userTypeConstant.Employee || user?.Type === userTypeConstant.Consultant) {
		@if (option.limitedEditionData.quantityAvailable > 0) {
		{{ 'LIMITED.AVAILABLE-LONG' | translate : { 'available' : option.limitedEditionData.quantityAvailable, 'total' : option.limitedEditionData.quantityTotal} }}
		}
		}
		@if (option.limitedEditionData.quantityAvailable <= 0 && option.limitedEditionData.quantityTotal> 0) {
			{{ 'LIMITED.SOLD-OUT-AMOUNT' | translate : { 'total' : option.limitedEditionData.quantityTotal} }}
		}
	</div>
	}
</div>
}

@if (!option && optionsCaption) {
<div>
	<div class="inner-column">
		<div class="description">
			<h6>{{optionsCaption | translate}}</h6>
		</div>
	</div>
</div>
}

@if (selected && showOverlay) {
<menu-overlay [mainOverlayText]="mainOverlayText" [secondOverlayText]="secondOverlayText" (overlayClicked)="onColorMatchClicked()">
</menu-overlay>
}